import { IncentiveType } from "./IncentiveType";
import { Territory } from "./Territory";
import { Utility } from "./Utility";

export interface IIncentiveProgram {
  incentiveProgramId: number;
  name: string;
  code: string;
  active: boolean;
  /** @deprecated Territory is deprecated. Use utilities instead. */
  territory: Territory;
  incentiveType: IncentiveType;
  utilities: Utility[];
}

export class IncentiveProgram implements IIncentiveProgram {
  public incentiveProgramId: number;
  public name: string;
  public code: string;
  public active: boolean;
  /** @deprecated Territory is deprecated. Use utilities instead. */
  public territory: Territory;
  public incentiveType: IncentiveType;
  public utilities: Utility[];
}
